import httpService from "./HttpService";

export async function createPrompt(prompt) {
  const token = localStorage.getItem("auth");
  return httpService.post(`prompts`, prompt, token);
}

export async function deletePrompt(id) {
  const token = localStorage.getItem("auth");
  return httpService.delete(`prompts/${id}`, null, token);
}

export async function getPromptsAvailable(companyId, category, type) {
  const token = localStorage.getItem("auth");
  const queryParams = {};

  if (companyId) {
    queryParams.companyId = companyId;
  }

  if (category) {
    queryParams.category = category;
  }

  if (type) {
    queryParams.type = type;
  }

  const queryString = Object.keys(queryParams).length > 0
      ? '?' + new URLSearchParams(queryParams).toString()
      : '';

  // Make the API call with the optional query string
  return httpService.get(`prompts/available${queryString}`, null, token);
}

// Updated getPrompts function to support all backend filters
export async function getPrompts(filters = {}) {
  const token = localStorage.getItem("auth");

  const queryParams = {};

  // Map all available filters from backend
  if (filters.companyId) {
    queryParams.companyId = filters.companyId;
  }

  if (filters.category) {
    queryParams.category = filters.category;
  }

  if (filters.type) {
    queryParams.type = filters.type;
  }

  if (filters.keyword) {
    queryParams.keyword = filters.keyword;
  }

  if (filters.nonSystemOnly !== undefined) {
    queryParams.nonSystemOnly = filters.nonSystemOnly;
  }

  if (filters.formatId) {
    queryParams.formatId = filters.formatId;
  }

  const queryString = Object.keys(queryParams).length > 0
      ? '?' + new URLSearchParams(queryParams).toString()
      : '';

  return httpService.get(`prompts${queryString}`, null, token);
}


export async function getPrompt(id) {
  const token = localStorage.getItem("auth");
  return httpService.get(`prompts/${id}`, null, token);
}

export async function updatePrompt(prompt) {
  const token = localStorage.getItem("auth");
  return httpService.put(`prompts`, prompt, token);
}